import { render, staticRenderFns } from "./answer-sheet4.vue?vue&type=template&id=14f79b25&scoped=true&"
import script from "./answer-sheet4.vue?vue&type=script&lang=js&"
export * from "./answer-sheet4.vue?vue&type=script&lang=js&"
import style0 from "./answer-sheet4.vue?vue&type=style&index=0&id=14f79b25&lang=scss&scoped=true&"
import style1 from "./answer-sheet4.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f79b25",
  null
  
)

export default component.exports